// extracted by mini-css-extract-plugin
export default {"whatTellContainer":"about_whatTellContainer__sMA2S","thecontent":"about_thecontent__y2r5G"};